import $ from 'domtastic'


// Views
import BaseView from '@views/_BaseView'
import Home from './views/Home'


const viewsMap = {
    home: Home,
    Base: BaseView,
}




/* ROUTER
----------------------------------------------------------------------------------------------------*/

export default class Router {

    constructor() {
        this.$els = {
            body     : $('body'),
            router   : $('.router'),
            navItems : $('.navItem'),
        }


        this.views = {}


        this.transitioning = true
        this.pageTitle     = document.title
        this.slug          = document.location.pathname + document.location.search
        this.view          = this.$els.body.attr('data-v')
        this.same          = false


        // Kickstart navigation
        this.bindEvents()
    }




    /* Navigation & Routing
    ---------------------------------------------------------*/

    bindEvents() {
        $(window).on('load', () => { this.onPageLoad(true) })
    }




    /* Handlers
    --------------------------------------------------------- */

    onPageLoad(firstLoad) {
        this.initPage(this.view)

        if (firstLoad) {
            this.transitioning = false
            this.$els.body.removeClass('transitioning')
        }
    }




    /* Actions
    ---------------------------------------------------------*/

    initPage(view) {
        Object.entries(this.views).forEach((v) => {
            v[1].destroy()
            delete this.views[v[0]]
        })

        this.views[view] = (viewsMap[view])
            ? new viewsMap[view]()
            : new viewsMap.Base({ namespace: `.${view}` })
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



